{
  "fr": {
    "pupilProjectStatus": {
      "switchError": "Erreur lors du changement de projet",
      "switchModal": {
        "joinAnotherClassroom": "Se déconnecter et changer de salle de classe",
        "loading": "Projets disponibles en cours de chargement...",
        "noOtherProjects": "Aucun autre projet disponible dans cette salle de classe.",
        "selectProject": "Vos contenus seront enregistrés dans ce projet :",
        "selectProjectPlaceholder": "Choisissez un projet pour changer",
        "title": "Affectation de projet"
      },
      "changeProject": "Changer de projet",
      "logoutError": "Erreur lors de la déconnexion",
      "switchSuccess": "Projet changé avec succès"
    }
  }
}
